import { useRef, useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
// creates a beautiful scrollbar
// import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

// core components
// Import the unstyled Sidebar component directly
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbars/Navbar';

import routes from '../routes';

import image from '../assets/img/sidebar-2.jpg';
import logo from '../assets/img/reactlogo.png';

export interface AdminProps {
  username: string;
  classes?: any;
}

const initialState = {
  image: image,
  color: 'blue',
  hasImage: true,
  fixedClasses: 'dropdown show',
  mobileOpen: false,
};

function Admin(props: AdminProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const username = props.username;

  const [state, setState] = useState(initialState);

  const handleDrawerToggle = () => {
    setState({ ...state, mobileOpen: !state.mobileOpen });
  }

  const getRoute = () => {
    return location.pathname !== '/admin/maps';
  }

  const mainPanel = useRef(null);
  const sidebarRef = useRef(null);
  // Use classes from the wrapper component's props if available
  const classes = props.classes || {};

  return (
    <div className={classes.wrapper}>
      <Sidebar
        ref={sidebarRef}
        routes={routes}
        logoText={'Hacklab'}
        logo={logo}
        image={state.image}
        handleDrawerToggle={handleDrawerToggle}
        open={state.mobileOpen}
        color={state.color}
        username={username}
        location={location}
        navigate={navigate}
      />
      <div className={`${classes.mainPanel} md:ml-[260px] transition-all duration-300`} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          location={location}
        />
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{SwitchRoutes({ username })}</div>
          </div>
        ) : (
          <div className={classes.map}>{SwitchRoutes({ username })}</div>
        )}
      </div>
    </div>
  );
}

const SwitchRoutes = ({ username }: { username: string }) => (
  <Routes>
    {routes.map((prop, key) => {
      if (prop.layout === '/admin') {
        return (
          <Route
            path={prop.path}
            element={<prop.component username={username} />}
            key={key}
          />
        );
      }
      return null;
    })}
  </Routes>
);

export default Admin;